export const UNKNOWN_ITEM_CLASS = 'UnknownClass';
export const META_CLASS_KEY = '$class';
export const DELETED_META_CLASS = 'DELETED';
